$(document).ready(function () {
  $(document).on('click', '.company-requests .toggle-module-accessors', function () {
    $('#module-accessors').toggle();
  });

  $(document).on('click', '.company-requests .toggle-permission-rules', function () {
    $('#project-accessors').toggle();
  });
});
